<template>
  <div class="pa-6">
    <!-- Breadcrumb and back button -->
    <v-row class="align-center bread-row">
      <v-col cols="12" md="10">
        <Breadcrump :crumbs="crumbs" />
      </v-col>
      <v-col cols="12" md="2" class="d-flex justify-end">
        <v-btn @click="$router.go(-1)" fab small dark color="#1976d2">
          <v-icon dark>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col> </v-row
    ><v-btn
      v-can="'MonitoringMessage_List'"
      small
      outlined
      color="blue lighten-1"
      class="mb-2"
      @click="showMessages = !showMessages"
    >
      <v-icon left small>
        {{ showMessages ? "mdi-eye-off" : "mdi-eye" }}
      </v-icon>
      {{ showMessages ? "مخفی کردن پیام‌ها" : "نمایش پیام‌ها"
      }}<span class="mr-2" style="color: red;" v-if="notSeen > 0"
        >({{ notSeen }})
      </span>
    </v-btn>
    <v-card
      v-if="hasPerm('MonitoringMessage_List')"
      v-show="showMessages"
      class="pa-4 elevation-3 mt-4"
    >
      <v-card-title
        class="title-font d-flex justify-space-between align-center"
      >
        پیام‌های پایش
        <div>
          <v-btn
            color="blue lighten-1"
            outlined
            small
            @click="resetMessageFilters"
          >
            <v-icon left small>mdi-filter-remove</v-icon>
            ریست فیلترها
          </v-btn>

          <v-btn
            v-can="'MonitoringMessage_ReadAll'"
            color="green lighten-1"
            outlined
            small
            class="mr-2"
            @click="confirmMarkAllAsRead"
          >
            <v-icon left small>mdi-eye-check-outline</v-icon>
            خواندن همه
          </v-btn>
        </div>
      </v-card-title>

      <v-data-table
        :loading="loadingMessages"
        :headers="messageHeaders"
        :items="filteredMessages"
        :server-items-length="messagePagination.totalItems"
        dense
        class="elevation-1"
        :page.sync="messagePagination.page"
        :items-per-page.sync="messagePagination.itemsPerPage"
        @update:page="onPageChange"
        @update:items-per-page="onItemsPerPageChange"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-arrow-left',
          nextIcon: 'mdi-arrow-right',
          itemsPerPageOptions: [5, 10, 25, 50]
        }"
        no-data-text="پیامی وجود ندارد"
        ><template v-slot:header.message="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small :color="messageFilter.message ? 'primary' : ''"
                  >mdi-magnify</v-icon
                >
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-text-field
                v-model="messageFilter.message"
                class="pa-4"
                type="search"
                label="جستجو"
                @input="filterMessageResult"
              ></v-text-field>
              <v-btn
                @click="filterMessageResult"
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >جستجو</v-btn
              >
              <v-btn
                @click="
                  messageFilter.message = null;
                  filterMessageResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.isSeen="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="messageFilter.isSeen.seen"
                class="pa-1 checkbox-top"
                type="text"
                label="خوانده شده"
                @change="filterMessageResult"
              ></v-checkbox>
              <v-checkbox
                v-model="messageFilter.isSeen.unseen"
                class="pa-1 checkbox"
                type="text"
                label="خوانده نشده"
                @change="filterMessageResult"
              ></v-checkbox>
              <v-btn
                @click="
                  messageFilter.isSeen.seen = true;
                  messageFilter.isSeen.unseen = true;
                  filterMessageResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ formatJalaliDate(item.createdAt) }}
        </template>
        <template v-slot:item.isSeen="{ item }">
          <v-chip
            :color="item.isSeen ? 'green darken-1' : 'grey darken-1'"
            dark
            small
          >
            {{ item.isSeen ? "خوانده شده" : "خوانده نشده" }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-can="'MonitoringMessage_Read'"
                v-bind="attrs"
                v-on="on"
                small
                :color="item.isSeen ? 'grey lighten-1' : 'green lighten-1'"
                :disabled="item.isSeen"
                rounded
                elevation="2"
                class="ma-1"
                @click="markAsRead(item)"
              >
                <v-icon left small>
                  mdi-eye-check
                </v-icon>
                خواندن
              </v-btn>
            </template>
            <span>{{
              item.isSeen ? "پیام خوانده شده" : "برای خواندن کلیک کنید"
            }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-card class="pa-4 elevation-3">
      <v-card-title
        class="title-font d-flex justify-space-between align-center"
      >
        وضعیت سلامت دستگاه‌ها
        <div>
          <v-btn
            color="green lighten-1"
            outlined
            small
            class="ml-2"
            @click="loadData"
            :loading="loading"
          >
            <v-icon left small>mdi-refresh</v-icon>
            بروزرسانی
          </v-btn>
          <v-btn color="blue lighten-1" outlined small @click="resetFilters">
            <v-icon left small>mdi-filter-remove</v-icon>
            ریست فیلترها
          </v-btn>
        </div>
      </v-card-title>

      <v-data-table
        :loading="loading"
        :headers="logHeaders"
        :items="filteredDeviceLogs"
        dense
        class="elevation-1"
        :items-per-page="10"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-arrow-left',
          nextIcon: 'mdi-arrow-right',
          itemsPerPageOptions: [5, 10, 25, 50]
        }"
        no-data-text="داده‌ای برای نمایش وجود ندارد"
      >
        <template v-slot:header.complexName="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small :color="filter.complexName ? 'primary' : ''"
                  >mdi-magnify</v-icon
                >
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-text-field
                v-model="filter.complexName"
                class="pa-4"
                type="search"
                label="جستجو"
                @input="filterResult"
              ></v-text-field>
              <v-btn
                @click="filter"
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >جستجو</v-btn
              >
              <v-btn
                @click="
                  filter.complexName = null;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.deviceName="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small :color="filter.deviceName ? 'primary' : ''"
                  >mdi-magnify</v-icon
                >
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-text-field
                v-model="filter.deviceName"
                class="pa-4"
                type="search"
                label="جستجو"
                @input="filterResult"
              ></v-text-field>
              <v-btn
                @click="filter"
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >جستجو</v-btn
              >
              <v-btn
                @click="
                  filter.deviceName = null;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.otaState="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-text-field
                v-model="filter.version"
                class="pa-4 input"
                type="search"
                label="ورژن"
                @input="filterResult"
              ></v-text-field>
              <v-checkbox
                v-model="filter.otaState.UpdateSuccessful"
                class="pa-1 checkbox"
                type="text"
                label="آپدیت موفق"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.otaState.UpdateFailed"
                class="pa-1 checkbox"
                type="text"
                label="آپدیت ناموفق"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.otaState.RestoreSuccessful"
                class="pa-1 checkbox"
                type="text"
                label="بازیابی موفق"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.otaState.NotMatch"
                class="pa-1 checkbox"
                type="text"
                label="نسخه ناهمخوان"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.otaState.RestoreFailed"
                class="pa-1 checkbox"
                type="text"
                label="بازیابی ناموفق"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.otaState.ManualUpdate"
                class="pa-1 checkbox"
                type="text"
                label="آپدیت دستی"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.otaState.Unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.version = null;
                  filter.otaState.ManualUpdate = true;
                  filter.otaState.RestoreFailed = true;
                  filter.otaState.RestoreSuccessful = true;
                  filter.otaState.NotMatch = true;
                  filter.otaState.UpdateFailed = true;
                  filter.otaState.UpdateSuccessful = true;
                  filter.otaState.Unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.caseDoorFlag="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.caseDoor.open"
                class="pa-1 checkbox-top"
                type="text"
                label="باز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.caseDoor.close"
                class="pa-1 checkbox"
                type="text"
                label="بسته"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.caseDoor.unknown"
                class="pa-1 checkbox"
                type="text"
                label="غیرفعال"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.caseDoor.open = true;
                  filter.caseDoor.close = true;
                  filter.caseDoor.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.smsLastState="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.sms.sent"
                class="pa-1 checkbox-top"
                type="text"
                label="موفق"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.sms.notSent"
                class="pa-1 checkbox"
                type="text"
                label="خطا در ارسال"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.sms.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.sms.inActive"
                class="pa-1 checkbox"
                type="text"
                label="غیرفعال"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.sms.warning"
                class="pa-1 checkbox"
                type="text"
                label="هشدار"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.sms.sent = true;
                  filter.sms.notSent = true;
                  filter.sms.unknown = true;
                  filter.sms.inActive = true;
                  filter.sms.warning = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.onlineState="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.onlineState.online"
                class="pa-1 checkbox-top"
                type="text"
                label="آنلاین مجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.onlineState.onlineNotInWorkingTime"
                class="pa-1 checkbox-top"
                type="text"
                label="آنلاین غیرمجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.onlineState.offline"
                class="pa-1 checkbox"
                type="text"
                label="آفلاین غیرمجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.onlineState.notInWorkingTime"
                class="pa-1 checkbox"
                type="text"
                label="آفلاین مجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.onlineState.offline = true;
                  filter.onlineState.online = true;
                  filter.onlineState.notInWorkingTime = true;
                  filter.onlineState.onlineNotInWorkingTime = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.shutDownState="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.shutDown.true"
                class="pa-1 checkbox-top"
                type="text"
                label="خاموش غیرمجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.shutDown.notInWorkingTime"
                class="pa-1 checkbox-top"
                type="text"
                label="خاموش مجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.shutDown.false"
                class="pa-1 checkbox"
                type="text"
                label="روشن مجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.shutDown.onNotInWorkingTime"
                class="pa-1 checkbox"
                type="text"
                label="روشن غیرمجاز"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.shutDown.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.shutDown.true = true;
                  filter.shutDown.false = true;
                  filter.shutDown.notInWorkingTime = true;
                  filter.shutDown.unknown = true;
                  filter.shutDown.onNotInWorkingTime = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <!-- <template v-slot:header.externalPowerIsConnected="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.externalPower.connected"
                class="pa-1 checkbox-top"
                type="text"
                label="وصل"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.externalPower.notConnected"
                class="pa-1 checkbox"
                type="text"
                label="قطع"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.externalPower.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.externalPower.connected = true;
                  filter.externalPower.notConnected = true;
                  filter.externalPower.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template> -->
        <template v-slot:header.memoryFlag="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.memory.success"
                class="pa-1 checkbox-top"
                type="text"
                label="OK"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.memory.warning"
                class="pa-1 checkbox"
                type="text"
                label="نزدیک به آستانه"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.memory.error"
                class="pa-1 checkbox"
                type="text"
                label="بالاتر از آستانه"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.memory.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.memory.success = true;
                  filter.memory.warning = true;
                  filter.memory.error = true;
                  filter.memory.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.lightBoxFlag="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.lightBox.success"
                class="pa-1 checkbox-top"
                type="text"
                label="سالم"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.lightBox.error"
                class="pa-1 checkbox"
                type="text"
                label="خطا"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.lightBox.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.lightBox.success = true;
                  filter.lightBox.error = true;
                  filter.lightBox.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.screenFlag="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.screen.success"
                class="pa-1 checkbox-top"
                type="text"
                label="سالم"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.screen.error"
                class="pa-1 checkbox"
                type="text"
                label="خطا"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.screen.unknown"
                class="pa-1 checkbox"
                type="text"
                label="غیرفعال"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.screen.success = true;
                  filter.screen.error = true;
                  filter.screen.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.lockerStatus="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.locker.success"
                class="pa-1 checkbox-top"
                type="text"
                label="سالم"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.locker.warning"
                class="pa-1 checkbox"
                type="text"
                label="هشدار"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.locker.error"
                class="pa-1 checkbox"
                type="text"
                label="خطا"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.locker.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.locker.success = true;
                  filter.locker.error = true;
                  filter.locker.warning = true;
                  filter.locker.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.databaseHealth="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.database.success"
                class="pa-1 checkbox-top"
                type="text"
                label="سالم"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.database.error"
                class="pa-1 checkbox"
                type="text"
                label="خطا"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.database.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.database.success = true;
                  filter.database.error = true;
                  filter.database.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.status="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.status.success"
                class="pa-1 checkbox-top"
                type="text"
                label="سالم"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.status.warning"
                class="pa-1 checkbox"
                type="text"
                label="هشدار"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.status.error"
                class="pa-1 checkbox"
                type="text"
                label="خطا"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.status.unknown"
                class="pa-1 checkbox"
                type="text"
                label="نامشخص"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.status.success = true;
                  filter.status.warning = true;
                  filter.status.error = true;
                  filter.status.unknown = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <template v-slot:header.isBranded="{ header }">
          {{ header.text }}
          <v-menu offset-y left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <div style="background-color: white; width: 200px">
              <v-checkbox
                v-model="filter.isBranded.branded"
                class="pa-1 checkbox-top"
                type="text"
                label="برند دارد"
                @change="filterResult"
              ></v-checkbox>
              <v-checkbox
                v-model="filter.isBranded.notbranded"
                class="pa-1 checkbox"
                type="text"
                label="فاقد برند"
                @change="filterResult"
              ></v-checkbox>
              <v-btn
                @click="
                  filter.isBranded.branded = true;
                  filter.isBranded.notbranded = true;
                  filterResult();
                "
                small
                text
                color="primary"
                class="ml-2 mb-2"
                >پاک کردن</v-btn
              >
            </div>
          </v-menu>
        </template>
        <!-- <template v-slot:item.createdAt="{ item }">
          {{ formatJalaliDate(item.createdAt) }}
        </template> -->
        <template v-slot:item.complexName="{ item }">
          <a @click="goToComplex(item)">
            {{ item.complexName }}
          </a>
        </template>
        <template v-slot:item.deviceName="{ item }">
          <a @click="goToDevice(item)">
            {{ item.deviceName }}
          </a>
        </template>
        <template
          v-for="field in dynamicLogKeys"
          v-slot:[`item.${field}`]="{ item }"
        >
          <v-chip
            v-if="isBooleanField(field)"
            :key="field"
            :color="getBooleanChipColor(item[field], field)"
            dark
            small
          >
            {{ formatBoolean(item[field], field) }}
          </v-chip>
          <span v-else :key="`Num_${field}`">
            {{ formatNumericField(item[field], field) }}
          </span> </template
        ><template v-slot:item.lightBoxFlag="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="getStatusChipColor(item.lightBoxFlag, 'lightBoxFlag')"
                v-bind="attrs"
                v-on="on"
              >
                {{ formatStatus(item.lightBoxFlag, "lightBoxFlag") }}</v-icon
              >
            </template>
            <span>{{
              formatDescStatus(item.lightBoxFlag, "lightBoxFlag")
            }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.screenFlag="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="getStatusChipColor(item.screenFlag, 'screenFlag')"
                v-bind="attrs"
                v-on="on"
              >
                {{ formatStatus(item.screenFlag, "screenFlag") }}</v-icon
              >
            </template>
            <span>{{ formatDescStatus(item.screenFlag, "screenFlag") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.lockerStatus="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a @click="goToDeviceLocker(item)">
                <v-icon
                  :color="getStatusChipColor(item.lockerStatus, 'lockerStatus')"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ formatStatus(item.lockerStatus, "lockerStatus") }}</v-icon
                >
              </a>
            </template>
            <span>{{
              formatDescStatus(item.lockerStatus, "lockerStatus")
            }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.databaseHealth="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="
                  getStatusChipColor(item.databaseHealth, 'databaseHealth')
                "
                v-bind="attrs"
                v-on="on"
              >
                {{
                  formatStatus(item.databaseHealth, "databaseHealth")
                }}</v-icon
              >
            </template>
            <span>{{
              formatDescStatus(item.databaseHealth, "databaseHealth")
            }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.memoryFlag="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="getStatusChipColor(item.memoryFlag, 'memoryFlag')"
                v-bind="attrs"
                v-on="on"
              >
                {{ formatStatus(item.memoryFlag, "memoryFlag") }}</v-icon
              >
            </template>
            <span>{{ formatDescStatus(item.memoryFlag, "memoryFlag") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.smsLastState="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a
                v-if="item.smsLastState === 1 || item.smsLastState === 2"
                @click="goToDeviceSms(item)"
              >
                <v-icon
                  :color="
                    getBooleanChipColor(item.smsLastState, 'smsLastState')
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ formatStatus(item.smsLastState, "smsLastState") }}</v-icon
                >
              </a>
              <v-icon
                v-else
                :color="getBooleanChipColor(item.smsLastState, 'smsLastState')"
                v-bind="attrs"
                v-on="on"
              >
                {{ formatStatus(item.smsLastState, "smsLastState") }}</v-icon
              >
            </template>
            <span>{{
              item.smsLastState != 4
                ? formatDescStatus(item.smsLastState, "smsLastState")
                : formatDescStatus(item.gameSmsLastState, "gameSmsLastState")
            }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.onlineState="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="
                  getOnlineStateChipColor(item.onlineState, 'onlineState')
                "
                v-bind="attrs"
                v-on="on"
              >
                {{ formatOnlineState(item.onlineState, "onlineState") }}
              </v-icon>
              <span v-if="item?.lastOnline" class="date-nowrap"
                >{{ formatJalaliDate(item.lastOnline) }}
              </span>
            </template>
            <span>{{
              formatDescOnlineState(item.onlineState, "onlineState")
            }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.otaState="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a v-if="item.otaState != 0" @click="goToDeviceOtaLog(item)">
                <v-icon
                  :color="getOtaStateChipColor(item.otaState, 'otaState')"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ formatOtaState(item.otaState, "otaState") }}
                </v-icon>
                <span>{{ item.version }}</span>
              </a>
              <v-icon
                v-else
                :color="getOtaStateChipColor(item.otaState, 'otaState')"
                v-bind="attrs"
                v-on="on"
              >
                {{ formatOtaState(item.otaState, "otaState") }}
              </v-icon>
            </template>
            <span>{{ formatDescOtaState(item.otaState, "otaState") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="getStatusChipColor(item.status, 'status')"
                v-bind="attrs"
                v-on="on"
              >
                {{ formatStatus(item.status, "status") }}</v-icon
              >
            </template>
            <span>{{ formatDescStatus(item.status, "status") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import request from "@/utils/request";
import { hasPermission } from "@/composables/permissions";
import { useSignalR } from "@/composables/useSignalR";
import Breadcrump from "@/components/common/Breadcrump.vue";
import _ from "lodash";

export default {
  name: "DeviceLogs",
  components: { Breadcrump },
  data() {
    return {
      activeTab: 0,
      crumbs: [
        { text: "خانه", href: "/", disabled: false },
        { text: "پایش سلامت دستگاه‌ها", disabled: true }
      ],
      notSeen: 0,
      showMessages: false,
      deviceHistory: [],
      messagePagination: {
        page: 1,
        itemsPerPage: 5,
        totalItems: 0
      },
      deviceHistoryTable: [],
      deviceLogs: [],
      filteredDeviceLogs: [],
      complexId: null,
      messages: [],
      filteredMessages: [],
      loadingMessages: false,
      messageFilter: {
        isSeen: {
          seen: true,
          unseen: true
        },
        message: null
      },
      filter: {
        complexName: null,
        deviceName: null,
        version: null,
        isBranded: {
          branded: true,
          notbranded: true
        },
        onlineState: {
          online: true,
          offline: true,
          notInWorkingTime: true,
          onlineNotInWorkingTime: true
        },
        status: {
          unknown: true,
          success: true,
          warning: true,
          error: true
        },
        caseDoor: {
          unknown: true,
          open: true,
          close: true
        },
        shutDown: {
          unknown: true,
          true: true,
          notInWorkingTime: true,
          false: true,
          onNotInWorkingTime: true
        },
        externalPower: {
          unknown: true,
          connected: true,
          notConnected: true
        },
        sms: {
          inActive: true,
          unknown: true,
          sent: true,
          notSent: true,
          warning: true
        },
        memory: {
          unknown: true,
          success: true,
          warning: true,
          error: true
        },
        screen: {
          unknown: true,
          success: true,
          error: true
        },
        locker: {
          unknown: true,
          success: true,
          warning: true,
          error: true
        },
        database: {
          unknown: true,
          success: true,
          error: true
        },
        lightBox: {
          unknown: true,
          success: true,
          error: true
        },
        otaState: {
          Unknown: true,
          UpdateSuccessful: true,
          UpdateFailed: true,
          RestoreFailed: true,
          ManualUpdate: true,
          RestoreSuccessful: true,
          NotMatch: true
        }
      },
      chart: null,
      logsChart: null,
      loading: false,
      plottableFields: [],
      selectedLogField: null,
      dynamicLogKeys: [],
      otaStateFieldMap: {
        otaState: {
          0: "mdi-help-circle",
          1: "mdi-check-circle",
          2: "mdi-alert-circle",
          3: "mdi-alert-circle",
          4: "mdi-update",
          5: "mdi-restore",
          6: "mdi-not-equal"
        }
      },
      otaStateFieldDescMap: {
        otaState: {
          0: "نامشخص",
          1: "آپدیت موفق",
          2: "آپدیت ناموفق",
          3: "بازیابی نسخه پیشین ناموفق",
          4: "آپدیت دستی",
          5: "نسخه پیشین بازیابی شد",
          6: "نسخه فعلی با نسخه آپدیت ناهمخوانی دارد"
        }
      },
      onlineStateFieldMap: {
        onlineState: {
          1: "mdi-wifi-off",
          2: "mdi-wifi-off",
          3: "mdi-wifi",
          4: "mdi-wifi-alert"
        }
      },
      onlineStateFieldDescMap: {
        onlineState: {
          1: "آفلاین غیرمجاز",
          2: "آفلاین مجاز",
          3: "آنلاین مجاز",
          4: "آنلاین غیرمجاز"
        }
      },
      statusFieldMap: {
        memoryFlag: {
          0: "mdi-help-circle",
          1: "mdi-check-circle",
          2: "mdi-alert-circle",
          3: "mdi-alert-circle"
        },
        status: {
          0: "mdi-help-circle",
          1: "mdi-check-circle",
          2: "mdi-alert-circle",
          3: "mdi-alert-circle"
        },
        lightBoxFlag: {
          0: "mdi-lightbulb-off",
          1: "mdi-lightbulb-on",
          2: "mdi-lightbulb-on"
        },
        screenFlag: {
          0: "mdi-monitor-off",
          1: "mdi-monitor",
          2: "mdi-monitor"
        },
        lockerStatus: {
          0: "mdi-help-circle",
          1: "mdi-check-circle",
          2: "mdi-alert-circle",
          3: "mdi-alert-circle"
        },
        databaseHealth: {
          0: "mdi-database",
          1: "mdi-database-check",
          2: "mdi-database-alert"
        },
        smsLastState: {
          0: "mdi-help-circle",
          1: "mdi-check-circle",
          2: "mdi-alert-circle",
          3: "mdi-message-off",
          4: "mdi-alert-circle"
        }
      },
      statusFieldDescMap: {
        memoryFlag: {
          0: "نامشخص",
          1: "OK",
          2: "نزدیک به آستانه",
          3: "بالاتر از آستانه"
        },
        status: {
          0: "نامشخص",
          1: "سالم",
          2: "هشدار",
          3: "خطا"
        },
        lightBoxFlag: {
          0: "غیرفعال",
          1: "سالم",
          2: "خطا"
        },
        screenFlag: {
          0: "غیرفعال",
          1: "سالم",
          2: "خطا"
        },
        lockerStatus: {
          0: "نامشخص",
          1: "سالم",
          2: "هشدار",
          3: "خطا"
        },
        databaseHealth: {
          0: "نامشخص",
          1: "سالم",
          2: "خطا"
        },
        smsLastState: {
          0: "نامشخص",
          1: "موفق",
          2: "خطا در ارسال",
          3: "غیرفعال",
          4: "هشدار"
        },
        gameSmsLastState: {
          0: "نامشخص",
          1: "دارای پیامک برد و باخت",
          2: "فافد پیامک باخت",
          3: "فاقد پیامک برد",
          4: "غیرفعال",
          5: "فاقد پیامک برد و باخت"
        }
      },
      booleanFieldMap: {
        caseDoorFlag: { 1: "باز", 2: "بسته", 0: "غیرفعال" },
        isBranded: { true: "دارد", false: "ندارد", null: "نامشخص" },
        shutDownState: {
          1: "خاموش غیرمجاز",
          2: "خاموش مجاز",
          3: "روشن مجاز",
          4: "روشن غیرمجاز",
          0: "نامشخص"
        },
        externalPowerIsConnected: {
          true: "متصل",
          false: "قطع",
          null: "نامشخص"
        },
        lightBoxFlag: { 0: "سالم", 1: "خطا", 2: "نامشخص" },
        screenFlag: { 0: "سالم", 1: "خطا", 2: "نامشخص" },
        lockerStatus: { 1: "سالم", 2: "هشدار", 3: "خطا", 0: "نامشخص" },
        databaseHealth: { 0: "سالم", 1: "خطا", 2: "نامشخص" },
        memoryFlag: {
          1: "OK",
          2: "نزدیک به آستانه",
          3: "بالاتر از آستانه",
          0: "نامشخص"
        }
      },
      numericFieldMap: {
        totalMemory: v => (v != null ? `${v} MB` : "-"),
        freeMemory: v => (v != null ? `${v} MB` : "-")
      }
    };
  },

  created() {
    this.debouncedLoadMessages = _.debounce(this.loadMonitoringMessages, 300);
  },
  computed: {
    messageHeaders() {
      return [
        { text: "پیام", value: "message" },
        { text: "وضعیت", value: "isSeen" },
        { text: "زمان", value: "createdAt" },
        { text: "عملیات", value: "actions", sortable: false }
      ];
    },
    logHeaders() {
      return [
        { text: "مجموعه", value: "complexName" },
        { text: "دستگاه", value: "deviceName" },
        // { text: "زمان", value: "createdAt" },
        ...this.dynamicLogKeys.map(key => ({
          text: this.formatFieldName(key),
          value: key
        })),
        { text: "وضعیت حافظه", value: "memoryFlag" },
        { text: "لایت باکس", value: "lightBoxFlag" },
        { text: "اسکرین", value: "screenFlag" },
        { text: "لاکر", value: "lockerStatus" },
        { text: "دیتابیس", value: "databaseHealth" },
        { text: "وضعیت پیامک", value: "smsLastState" },
        { text: "وضعیت اتصال", value: "onlineState" },
        { text: "وضعیت آخرین نسخه", value: "otaState" },
        { text: "وضعیت", value: "status" }
      ];
    }
  },
  beforeDestroy() {
    window.removeEventListener("new-monitoring-message", this.handleNewMessage);
  },
  mounted() {
    const { setNotifAsSeen } = useSignalR();
    setNotifAsSeen();
    if (hasPermission("MonitoringMessage_List"))
      window.addEventListener("new-monitoring-message", this.handleNewMessage);
    this.loadData();

    if (hasPermission("MonitoringMessage_List")) this.loadMonitoringMessages();
  },
  methods: {
    hasPerm(item) {
      return hasPermission(item);
    },
    handleNewMessage(event) {
      const message = event.detail;

      if (this.messagePagination.page === 1) {
        this.addRealtimeMessage(message);
      } else {
        this.notSeen++;
      }
    },
    addRealtimeMessage(newMessage) {
      const pageSize = this.messagePagination.itemsPerPage;
      let increment = newMessage.isNew ? 1 : 0;

      const existingIndex = this.messages.findIndex(
        m => m.notificationId === newMessage.notificationId
      );
      if (existingIndex !== -1) {
        this.messages.splice(existingIndex, 1);
      }

      this.messages.unshift({ ...newMessage, isSeen: false });

      this.filteredMessages = this.messages.slice(0, pageSize);

      this.messagePagination.totalItems += increment;

      this.notSeen += increment;
    },
    confirmMarkAllAsRead() {
      if (
        window.confirm(
          "آیا مطمئن هستید که می‌خواهید همه پیام‌ها را به عنوان خوانده شده علامت بزنید؟"
        )
      ) {
        this.markAllAsRead();
      }
    },
    async loadMonitoringMessages() {
      this.loadingMessages = true;
      try {
        const response = await request.get(
          "/notification/monitoring-messages",
          {
            params: {
              page: this.messagePagination.page,
              itemsPerPage: this.messagePagination.itemsPerPage,
              sortBy: "createdAt",
              mustSort: true,
              sortDesc: true,
              message: this.messageFilter.message,
              isSeen: this.messageFilter.isSeen.seen,
              isNotSeen: this.messageFilter.isSeen.unseen
            }
          }
        );
        this.messages = Array.isArray(response.data.result?.result)
          ? response.data.result?.result
          : [];
        this.notSeen = response.data.result?.extraValue || 0;
        this.messagePagination.totalItems =
          response.data.result?.totalItems || 0;

        this.filteredMessages = [...this.messages];
      } catch (error) {
        this.messages = [];
        this.filteredMessages = [];
        this.$notify({
          group: "notifications",
          title: "خطا",
          text: "دریافت پیام‌ها با خطا مواجه شد",
          type: "error"
        });
      } finally {
        this.loadingMessages = false;
      }
    },

    filterMessageResult() {
      this.filteredMessages = this.messages;
      if (this.messageFilter.message && this.messageFilter.message.length < 3)
        return;
      this.loadMonitoringMessages();
      this.filteredMessages = this.messages;
    },

    resetMessageFilters() {
      this.messageFilter = {
        isSeen: { seen: true, unseen: true },
        deviceName: null,
        complexName: null
      };
      this.loadMonitoringMessages();
      this.filteredMessages = [...this.messages];
    },
    resetFilters() {
      this.filter = {
        complexName: null,
        deviceName: null,
        isBranded: {
          branded: true,
          notbranded: true
        },
        onlineState: {
          online: true,
          offline: true,
          notInWorkingTime: true,
          onlineNotInWorkingTime: true
        },
        status: {
          unknown: true,
          success: true,
          warning: true,
          error: true
        },
        caseDoor: {
          unknown: true,
          open: true,
          close: true
        },
        shutDown: {
          unknown: true,
          true: true,
          notInWorkingTime: true,
          false: true,
          onNotInWorkingTime: true
        },
        externalPower: {
          unknown: true,
          connected: true,
          notConnected: true
        },
        sms: {
          inActive: true,
          unknown: true,
          sent: true,
          notSent: true,
          warning: true
        },
        memory: {
          unknown: true,
          success: true,
          warning: true,
          error: true
        },
        screen: {
          unknown: true,
          success: true,
          error: true
        },
        locker: {
          unknown: true,
          success: true,
          warning: true,
          error: true
        },
        database: {
          unknown: true,
          success: true,
          error: true
        },
        lightBox: {
          unknown: true,
          success: true,
          error: true
        },
        otaState: {
          version: null,
          Unknown: true,
          UpdateSuccessful: true,
          UpdateFailed: true,
          RestoreFailed: true,
          ManualUpdate: true,
          RestoreSuccessful: true,
          NotMatch: true
        }
      };

      // ریست نتیجه فیلتر
      this.filteredDeviceLogs = this.deviceLogs;
    },
    onPageChange(newPage) {
      this.messagePagination.page = newPage;
      this.loadMonitoringMessages(); // اگر نیاز به ری‌لود داده‌ها از سرور دارید
    },
    onItemsPerPageChange(newItemsPerPage) {
      this.messagePagination.itemsPerPage = newItemsPerPage;
      this.messagePagination.page = 1; // معمولا وقتی تعداد آیتم تغییر می‌کنه، صفحه رو به 1 برمیگردونیم
      this.loadMonitoringMessages();
    },
    formatOtaState(value, key) {
      return this.otaStateFieldMap[key]?.[value] ?? value;
    },
    formatDescOtaState(value, key) {
      return this.otaStateFieldDescMap[key]?.[value] ?? value;
    },
    getOtaStateChipColor(value, key) {
      const colors = {
        otaState: {
          1: "green darken-1",
          2: "red darken-1",
          3: "red darken-1",
          4: "grey darken-1",
          5: "yellow darken-1",
          6: "yellow darken-1"
        }
      };
      return colors[key]?.[value] || "blue darken-1";
    },
    formatOnlineState(value, key) {
      return this.onlineStateFieldMap[key]?.[value] ?? value;
    },
    formatDescOnlineState(value, key) {
      return this.onlineStateFieldDescMap[key]?.[value] ?? value;
    },
    getOnlineStateChipColor(value, key) {
      const colors = {
        onlineState: {
          1: "red darken-1",
          2: "grey darken-1",
          3: "green darken-1",
          4: "red darken-1"
        }
      };
      return colors[key]?.[value] || "blue darken-1";
    },
    filterResult() {
      this.filteredDeviceLogs = this.deviceLogs;
      if (this.filter.complexName)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(x =>
          x.complexName
            .toLowerCase()
            .includes(this.filter.complexName.toLowerCase())
        );

      if (this.filter.deviceName)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(x =>
          x.deviceName
            .toLowerCase()
            .includes(this.filter.deviceName.toLowerCase())
        );

      if (!this.filter.status.success)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.status != 1
        );
      if (!this.filter.status.warning)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.status != 2
        );
      if (!this.filter.status.error)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.status != 3
        );
      if (!this.filter.status.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.status != 0
        );

      if (!this.filter.otaState.UpdateSuccessful)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.otaState != 1
        );
      if (!this.filter.otaState.UpdateFailed)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.otaState != 2
        );
      if (!this.filter.otaState.RestoreFailed)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.otaState != 3
        );
      if (!this.filter.otaState.ManualUpdate)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.otaState != 4
        );
      if (!this.filter.otaState.RestoreSuccessful)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.otaState != 5
        );
      if (!this.filter.otaState.NotMatch)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.otaState != 6
        );
      if (!this.filter.otaState.Unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.otaState != 0
        );
      if (this.filter.version)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(x =>
          x.version?.toLowerCase().includes(this.filter.version.toLowerCase())
        );

      if (!this.filter.isBranded.branded)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.isBranded != true
        );
      if (!this.filter.isBranded.notbranded)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.isBranded != false
        );

      if (!this.filter.lightBox.success)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.lightBoxFlag != 1
        );
      if (!this.filter.lightBox.error)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.lightBoxFlag != 2
        );
      if (!this.filter.lightBox.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.lightBoxFlag != 0
        );

      if (!this.filter.screen.success)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.screenFlag != 1
        );
      if (!this.filter.screen.error)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.screenFlag != 2
        );
      if (!this.filter.screen.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.screenFlag != 0
        );

      if (!this.filter.locker.success)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.lockerStatus != 1
        );
      if (!this.filter.locker.warning)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.lockerStatus != 2
        );
      if (!this.filter.locker.error)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.lockerStatus != 3
        );
      if (!this.filter.locker.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.lockerStatus != 0
        );

      if (!this.filter.database.success)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.databaseHealth != 1
        );
      if (!this.filter.database.error)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.databaseHealth != 2
        );
      if (!this.filter.database.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.databaseHealth != 0
        );

      if (!this.filter.caseDoor.open)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.caseDoorFlag != 1
        );
      if (!this.filter.caseDoor.close)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.caseDoorFlag != 2
        );
      if (!this.filter.caseDoor.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.caseDoorFlag != 0
        );

      if (!this.filter.onlineState.offline)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.onlineState != 1
        );
      if (!this.filter.onlineState.notInWorkingTime)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.onlineState != 2
        );
      if (!this.filter.onlineState.online)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.onlineState != 3
        );
      if (!this.filter.onlineState.onlineNotInWorkingTime)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.onlineState != 4
        );

      if (!this.filter.shutDown.true)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.shutDownState != 1
        );
      if (!this.filter.shutDown.notInWorkingTime)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.shutDownState != 2
        );
      if (!this.filter.shutDown.false)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.shutDownState != 3
        );
      if (!this.filter.shutDown.onNotInWorkingTime)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.shutDownState != 4
        );
      if (!this.filter.shutDown.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.shutDownState != 0
        );

      if (!this.filter.externalPower.connected)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.externalPowerIsConnected != true
        );
      if (!this.filter.externalPower.notConnected)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.externalPowerIsConnected != false
        );
      if (!this.filter.externalPower.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.externalPowerIsConnected != null
        );

      if (!this.filter.sms.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.smsLastState != 0
        );
      if (!this.filter.sms.sent)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.smsLastState != 1
        );
      if (!this.filter.sms.notSent)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.smsLastState != 2
        );
      if (!this.filter.sms.inActive)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.smsLastState != 3
        );
      if (!this.filter.sms.warning)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.smsLastState != 4
        );

      if (!this.filter.memory.success)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.memoryFlag != 1
        );
      if (!this.filter.memory.warning)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.memoryFlag != 2
        );
      if (!this.filter.memory.error)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.memoryFlag != 3
        );
      if (!this.filter.memory.unknown)
        this.filteredDeviceLogs = this.filteredDeviceLogs.filter(
          x => x.memoryFlag != 0
        );
    },
    loadData() {
      this.resetFilters();
      this.loadDeviceLogs();
    },
    goToDevice(item) {
      this.$store.commit("setSelectedDeviceName", item.deviceName);
      this.$store.commit("setSelectedComplexName", item.complexName);
      this.$store.commit("setSelectedComplexId", item.complexId);
      const route = this.$router.resolve(`/device-summary/${item.deviceId}`);
      window.open(route.href, "_blank");
    },
    goToDeviceLocker(item) {
      this.$store.commit("setSelectedDeviceName", item.deviceName);
      this.$store.commit("setSelectedComplexName", item.complexName);
      this.$store.commit("setSelectedComplexId", item.complexId);
      const route = this.$router.resolve(
        `/device-state/${item.complexId}/${item.deviceId}`
      );
      window.open(route.href, "_blank");
    },
    goToDeviceSms(item) {
      this.$store.commit("setSelectedDeviceName", item.deviceName);
      this.$store.commit("setSelectedComplexName", item.complexName);
      this.$store.commit("setSelectedComplexId", item.complexId);
      const route = this.$router.resolve(`/device-sms/${item.deviceId}`);
      window.open(route.href, "_blank");
    },
    goToDeviceOtaLog(item) {
      this.$store.commit("setSelectedDeviceName", item.deviceName);
      this.$store.commit("setSelectedComplexName", item.complexName);
      this.$store.commit("setSelectedComplexId", item.complexId);
      const route = this.$router.resolve(`/device-ota-logs/${item.deviceId}`);
      window.open(route.href, "_blank");
    },
    goToComplex(item) {
      this.$store.commit("setSelectedDeviceName", item.deviceName);
      this.$store.commit("setSelectedComplexName", item.complexName);
      this.$store.commit("setSelectedComplexId", item.complexId);
      const route = this.$router.resolve(`/complex-units/${item.complexId}`);
      window.open(route.href, "_blank");
    },
    async markAllAsRead() {
      try {
        await request.put(`/Notification/monitoring-messages/all`);
        this.filteredMessages.forEach(item => (item.isSeen = true));
        this.notSeen = 0;

        this.$notify({
          group: "notifications",
          title: "موفق",
          text: "تمام پیام‌ها به عنوان خوانده شده علامت‌گذاری شد",
          type: "success"
        });
      } catch (error) {
        this.$notify({
          group: "notifications",
          title: "خطا",
          text: "خواندن پیام با خطا مواجه شد",
          type: "error"
        });
      }
    },
    async markAsRead(item) {
      try {
        await request.put(
          `/Notification/monitoring-messages/${item.notificationId}`
        );

        this.notSeen = this.notSeen - 1;
        if (this.notSeen < 0) this.notSeen = 0;
        item.isSeen = true;

        this.$notify({
          group: "notifications",
          title: "موفق",
          text: "پیام به عنوان خوانده شده علامت‌گذاری شد",
          type: "success"
        });
      } catch (error) {
        this.$notify({
          group: "notifications",
          title: "خطا",
          text: "خواندن پیام با خطا مواجه شد",
          type: "error"
        });
      }
    },

    async loadDeviceLogs() {
      this.loading = true;
      try {
        const response = await request.get(`/DeviceLog/devices`);

        const logs = Array.isArray(response.data.result?.deviceLog)
          ? response.data.result.deviceLog
          : [];
        this.deviceLogs = logs;
        this.filteredDeviceLogs = logs;

        this.extractDynamicFields(logs);
      } catch (error) {
        this.deviceLogs = [];
        this.filteredDeviceLogs = [];
        this.plottableFields = [];
        this.dynamicLogKeys = [];
        this.$notify({
          group: "notifications",
          title: "خطا",
          text: "دریافت لاگ‌ها با خطا مواجه شد",
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    },

    extractDynamicFields(logs) {
      if (!logs.length) {
        this.dynamicLogKeys = [];
        this.plottableFields = [];
        return;
      }
      const sample = logs[0];
      const keys = Object.keys(sample).filter(
        k =>
          ![
            "id",
            "deviceId",
            "shutDownState",
            "lastOnline",
            "version",
            "createdAt",
            "lightBoxNumber",
            "smsLastState",
            "gameSmsLastState",
            "shutDownFlag",
            "status",
            "complexName",
            "deviceName",
            "complexId",
            "otaState",
            "totalMemory",
            "freeMemory",
            "lightBoxStatus",
            "lightBoxFlag",
            "screenFlag",
            "lockerStatus",
            "caseDoor",
            "screenStatus",
            "databaseHealth",
            "memoryFlag",
            "onlineState",
            "externalPowerIsConnected"
          ].includes(k)
      );
      this.dynamicLogKeys = keys;
      this.plottableFields = keys
        .map(key => {
          const values = logs
            .map(log => log[key])
            .filter(v => v !== null && v !== "" && v !== undefined);
          if (values.length === 0) return null;
          const allNumbers = values.every(
            v => !isNaN(parseFloat(v)) && isFinite(v)
          );
          const allBooleans = values.every(
            v => v === true || v === false || v === null
          );
          if (allBooleans && this.booleanFieldMap[key] !== undefined) {
            return {
              value: key,
              text: this.formatFieldName(key),
              type: "boolean"
            };
          }
          if (allNumbers) {
            return {
              value: key,
              text: this.formatFieldName(key),
              type: "number"
            };
          }
          return null;
        })
        .filter(Boolean);
    },

    formatFieldName(key) {
      const map = {
        caseDoorFlag: "درب کیس",
        isBranded: "برند",
        shutDownState: "وضعیت خاموشی",
        lightBoxFlag: "لایت باکس",
        screenFlag: "اسکرین",
        lockerStatus: "لاکر",
        databaseHealth: "دیتابیس",
        externalPowerIsConnected: "برق خارجی",
        memoryFlag: "وضعیت حافظه"
      };
      return map[key] || key;
    },

    isBooleanField(key) {
      return this.booleanFieldMap[key] !== undefined;
    },

    formatBoolean(value, key) {
      return this.booleanFieldMap[key]?.[value] ?? value;
    },

    isStatusField(key) {
      return this.statusFieldMap[key] !== undefined;
    },

    formatStatus(value, key) {
      return this.statusFieldMap[key]?.[value] ?? value;
    },

    formatDescStatus(value, key) {
      return this.statusFieldDescMap[key]?.[value] ?? value;
    },

    getBooleanChipColor(value, key) {
      const colors = {
        caseDoorFlag: { true: "red darken-1", false: "green darken-1" },
        isBranded: { false: "grey", true: "green darken-1" },
        shutDownState: {
          1: "red darken-1",
          2: "green darken-1",
          3: "green darken-1",
          4: "red darken-1"
        },
        externalPowerIsConnected: {
          true: "green darken-1",
          false: "yellow darken-1"
        },
        smsLastState: {
          1: "green darken-1",
          2: "red darken-1",
          4: "yellow darken-1"
        },
        lockerStatus: {
          1: "green darken-1",
          3: "red darken-1",
          2: "yellow darken-1"
        },
        lightBoxFlag: { 1: "green darken-1", 2: "red darken-1" },
        screenFlag: { 1: "green darken-1", 2: "red darken-1" },
        databaseHealth: { 1: "green darken-1", 2: "red darken-1" },
        memoryFlag: {
          1: "green darken-1",
          2: "yellow darken-1",
          3: "red darken-1"
        }
      };
      return colors[key]?.[value] || "blue";
    },

    getStatusChipColor(value, key) {
      const colors = {
        status: {
          1: "green darken-1",
          2: "yellow darken-1",
          3: "red darken-1"
        },
        memoryFlag: {
          1: "green darken-1",
          2: "yellow darken-1",
          3: "red darken-1"
        },
        lightBoxFlag: { 1: "green darken-1", 2: "red darken-1" },
        screenFlag: { 1: "green darken-1", 2: "red darken-1" },
        lockerStatus: {
          1: "green darken-1",
          3: "red darken-1",
          2: "yellow darken-1"
        },
        databaseHealth: { 1: "green darken-1", 2: "red darken-1" }
      };
      return colors[key]?.[value] || "blue darken-1";
    },

    formatNumericField(value, key) {
      if (value == null || value === "") return "-";
      if (this.numericFieldMap[key]) {
        const mapper = this.numericFieldMap[key];
        return typeof mapper === "function"
          ? mapper(value)
          : mapper[value] ?? value;
      }
      return value;
    },

    resetLogSelection() {
      this.selectedLogField = null;
    },

    formatJalaliDate(datetime) {
      if (!datetime) return "-";
      try {
        return moment(datetime).format("jYYYY/jMM/jDD HH:mm:ss");
      } catch {
        return "-";
      }
    }
  }
};
</script>

<style scoped>
.IranSans {
  font-family: "IranSans", sans-serif !important;
}

.pa-6 {
  padding: 4px !important;
  min-height: 100vh;
}

.date-nowrap {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: 4px;
  font-size: 12px;
  direction: ltr;
  unicode-bidi: embed;
}

.bread-row {
  margin-bottom: 4px !important;
  margin-top: -8px !important;
}

.calendar-row {
  margin-top: 0px !important;
  margin-bottom: 24px;
  padding-right: 8px;
  padding-left: 8px;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.calendar-wrapper {
  display: flex;
  flex-direction: column;
}

.calendar-label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

.chart-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.chart-container {
  position: relative;
  height: 260px;
  margin-top: 12px;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}

.v-card {
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.2s ease;
}
.v-card:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
}

.v-card-title {
  font-weight: 600;
  font-size: 17px !important;
  color: #1a1a1a;
}

.title-font {
  font-family: "IranSans", sans-serif !important;
  font-weight: 600 !important;
}

.checkbox {
  margin-bottom: 1px !important;
  margin-top: 1px !important;
}

.input {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.checkbox-top {
  margin-top: 8px !important;
  margin-bottom: 1px !important;
}

.v-data-table {
  font-size: 13.5px;
  border-radius: 12px;
  overflow: hidden;
}

.v-chip {
  font-size: 12px;
  font-weight: 500;
}

.field-select {
  max-width: 320px;
}

.v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600;
}

@media (max-width: 960px) {
  .calendar-row {
    gap: 12px;
  }
  .chart-container {
    height: 300px;
  }
}
@media (max-width: 600px) {
  .pa-6 {
    padding: 12px !important;
  }
  .chart-container {
    height: 340px;
  }
  .v-card-title {
    font-size: 16px !important;
  }
}
</style>
